import LoopbackProvider from './LoopbackProvider';
import {
  setLoading,
} from '../redux/actions';

export interface LoopbackFilter {
  fields?: Record<string, boolean>;
  include?: string|string[]|Record<string, string|string[]|Record<string, unknown>>
  limit?: number;
  order?: string;
  skip?: number;
  where?: Record<string, unknown>;
}

type Options = {
  method: string;
  headers: Headers;
  body?: string;
}

async function loopbackRequest(
  method: string, path: string, payload = {},
) {
  const host = LoopbackProvider.loopbackHost;
  const token = LoopbackProvider.loopbackToken;
  const { store } = LoopbackProvider;
  const headers = new Headers();
  headers.append('content-type', 'application/json');
  if (token) {
    headers.append('Authorization', token.id);
  }
  const options: Options = { method, headers };
  if (method !== 'GET') {
    options.body = JSON.stringify(payload);
  }
  try {
    const response = await fetch(`${host}${path}`, options); // eslint-disable-line no-undef
    if (!response.ok) {
      const loopbackError = new Error(
        JSON.stringify(response.statusText),
      ) as Error & { status: number };
      loopbackError.status = response.status;
      // eslint-disable-next-line no-useless-catch
      try {
        const json = await response.json();
        loopbackError.message = json.error.message;
      } catch (error) {
        throw error;
      }
      throw loopbackError;
    }
    return (response.status !== 204) ? response.json() : {};
  } catch (error) {
    if ((error as any).message.toLowerCase().indexOf('authorization required') > -1
        && (error as any).status === 401) {
      LoopbackProvider.handleUnauthorization();
    }

    store.dispatch(setLoading(false));
    throw error;
  }
}

export function loopbackGet(url: string): any {
  return loopbackRequest('GET', url, undefined);
}

export function loopbackPost(
  endpoint: string, payload?: any,
): any {
  return loopbackRequest('POST', endpoint, payload);
}

export function loopbackPut(endpoint: string, payload?: any): any {
  return loopbackRequest('PUT', endpoint, payload);
}

export function loopbackPatch(
  endpoint: string, payload?: any,
): any {
  return loopbackRequest('PATCH', endpoint, payload);
}

export function loopbackDelete(endpoint: string): any {
  return loopbackRequest('DELETE', endpoint);
}
